var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_677_7082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4132 2.25L8.62158 12.75C8.59599 12.8058 8.5549 12.8532 8.5032 12.8864C8.45149 12.9195 8.39135 12.9372 8.32992 12.9372C8.26848 12.9372 8.20834 12.9195 8.15664 12.8864C8.10493 12.8532 8.06384 12.8058 8.03825 12.75L5.99658 8.66667L1.91325 6.625C1.8574 6.59941 1.81007 6.55832 1.77689 6.50661C1.74371 6.45491 1.72607 6.39477 1.72607 6.33333C1.72607 6.2719 1.74371 6.21176 1.77689 6.16005C1.81007 6.10835 1.8574 6.06726 1.91325 6.04167L12.4132 2.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_7082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.163086 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.95dc8b62c183e7d33becef2cdd212abe.svg";
export { ForwardRef as ReactComponent };